import { render, staticRenderFns } from "./MListSimple.vue?vue&type=template&id=6c644267&scoped=true&"
import script from "./MListSimple.vue?vue&type=script&lang=js&"
export * from "./MListSimple.vue?vue&type=script&lang=js&"
import style0 from "./MListSimple.vue?vue&type=style&index=0&id=6c644267&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c644267",
  null
  
)

export default component.exports